import PropTypes from 'prop-types';

import {
  OverBarContainer,
  ProgressBarContainer,
  ProgressBarStyled,
  StepsCounter,
  TitleStyled,
} from './TrlProgressBar.styles';

export const TrlProgressBar = ({ title, totalSteps, currentStep }) => (
  <ProgressBarContainer>
    <OverBarContainer>
      <TitleStyled>{title}</TitleStyled>
      <StepsCounter>
        ({currentStep}/{totalSteps})
      </StepsCounter>
    </OverBarContainer>
    <ProgressBarStyled
      variant="determinate"
      value={(currentStep / totalSteps) * 100}
    />
  </ProgressBarContainer>
);

TrlProgressBar.propTypes = {
  title: PropTypes.string.isRequired,
  totalSteps: PropTypes.number.isRequired,
  currentStep: PropTypes.number.isRequired,
};
